import { contactConnectedDate, type Contact } from "./domain";

export interface RelationshipPriority {
  contact: Contact;
  score: number;
  signals: string;
}

export function relationshipPriority(contact: Contact, now = new Date()): RelationshipPriority {
  const today = startOfDay(now);
  const due = parseDateKey(contact.followUpDate);
  const dueDays = due ? dayDifference(today, due) : null;
  const relationshipDate = contact.lastFollowedUpAt?.toDate?.() ?? contactConnectedDate(contact);
  const inactiveDays = relationshipDate ? Math.max(0, dayDifference(startOfDay(relationshipDate), today)) : null;
  const dueScore = dueDays == null ? 30 : dueDays <= 0 ? 55 + Math.min(20, Math.abs(dueDays)) : Math.max(10, 35 - dueDays);
  const inactivityScore = Math.min(20, Math.floor((inactiveDays ?? 0) / 30) * 2);
  const score = Math.min(100, dueScore + contact.relationshipStrength * 6 + inactivityScore);
  const signals = [
    dueDays == null ? "No date" : dueDays < 0 ? `${Math.abs(dueDays)}d overdue` : dueDays === 0 ? "Due today" : `Due in ${dueDays}d`,
    contact.relationshipStrength > 0 ? `${contact.relationshipStrength}★` : "",
    inactiveDays == null ? "" : `${inactiveDays}d since contact`,
  ].filter(Boolean).join(" · ");
  return { contact, score, signals };
}

export function rankRelationshipFollowUps(contacts: Contact[], now = new Date()) {
  return contacts.map((contact) => relationshipPriority(contact, now)).sort((left, right) => right.score - left.score || left.contact.displayName.localeCompare(right.contact.displayName));
}

function parseDateKey(value: string) { const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/); return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null; }
function startOfDay(value: Date) { return new Date(value.getFullYear(), value.getMonth(), value.getDate()); }
function dayDifference(from: Date, to: Date) { return Math.round((to.getTime() - from.getTime()) / 86_400_000); }
